import React from 'react';
import { createRoot } from "react-dom/client"
import "./index.css"
import App from "./App.tsx"
import { HeaperInitScript, IntercomInitScript } from "./integrations/heaper"

createRoot(document.getElementById("root") as HTMLElement).render(
	<React.StrictMode>
		<HeaperInitScript />
		<IntercomInitScript />
		<App />
	</React.StrictMode>
)
